module.exports = __webpack_public_path__ + "img/ne.01cfd5bd.svg";